import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@nerdwallet/react-typography';

var Fee = function Fee(_ref) {
  var data = _ref.data;

  if (data.managementFee === null || data.managementFee === undefined) {
    return null;
  }

  var suffix = data.feePeriod;

  if (suffix) {
    suffix = React.createElement("span", {
      className: "annotation"
    }, React.createElement(Text, {
      small: true
    }, suffix));
  }

  return React.createElement("div", {
    className: "product-label product-value"
  }, data.managementFee, suffix);
};

Fee.propTypes = {
  data: PropTypes.object
};
export default Fee;